import React, { Component } from 'react';
import { StyleSheet, Animated, TouchableWithoutFeedback, View } from 'react-native';
import { observer } from 'mobx-react';
import { observe } from 'mobx';
import Text from './Text';
import Image from './Image';

import appStore from '../../stores/app';

import { FONT_FAMILY_BOLD, GOLDEN200, pOrT } from '../styleConstants';

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    zIndex: 9,
  },
  wrapper: {
    marginTop: pOrT(4, 20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  success: {},
  error: {
    color: '#ff7e9e',
  },
  text: {
    color: GOLDEN200,
    fontSize: pOrT(12, 14),
    fontFamily: FONT_FAMILY_BOLD,
  },
});

const DELAY = 1000;

const DELAY_SUCCESS = DELAY;
const DELAY_ERROR = 2000;

type Props = {
  modal?: boolean;
};

type State = {
  top: any;
  opacity: any;
};

@observer
export default class Message extends Component<Props, State> {
  state = {
    top: new Animated.Value(-65),
    opacity: new Animated.Value(0),
  };

  disposer: any;

  hideAnimationFinished: boolean = true;

  hideMessageTimeout: any;

  constructor(props: Props) {
    super(props);
    this.disposer = observe(appStore, 'message', () => {
      this.check();
    });
  }

  componentWillUnmount() {
    this.disposer();
  }

  hideMessage = () => {
    const { top, opacity } = this.state;
    if (!this.hideAnimationFinished) return;
    this.hideAnimationFinished = false;

    Animated.spring(opacity, { toValue: 0 } as any).start(() => {
      Animated.spring(top, { toValue: -65, speed: 1000 } as any).start(() => {
        this.hideAnimationFinished = true;
        clearTimeout(this.hideMessageTimeout);
      });
    });
  };

  check() {
    const { modal } = this.props;
    const { top, opacity } = this.state;

    if (!appStore.message) return;

    if (appStore.message.hideMsg) {
      this.hideMessage();
      return;
    }

    if (modal || (!modal && !appStore.modalOpened)) {
      Animated.spring(top, { toValue: 20, speed: 1000 } as any).start(() => {
        Animated.spring(opacity, { toValue: 1 } as any).start(() => {
          clearTimeout(this.hideMessageTimeout);
          let delay = DELAY;
          if (appStore.message?.delay) {
            delay = appStore.message.delay;
          } else if (appStore.message?.type === 'error') {
            delay = DELAY_ERROR;
          } else if (appStore.message?.type === 'success') {
            delay = DELAY_SUCCESS;
          } else {
            delay = DELAY;
          }
          this.hideMessageTimeout = setTimeout(this.hideMessage, delay);
        });
      });
    }
  }

  render() {
    if (!appStore.message) return null;

    const { top, opacity } = this.state;
    const { text, type } = appStore.message;

    // this.check();

    return (
      <TouchableWithoutFeedback onPress={this.hideMessage}>
        <Animated.View
          style={[styles.container, styles.wrapper, (styles as any)[type!], { top, opacity }]}
        >
          <Image
            style={{ height: 45, width: 450, position: 'absolute' }}
            source={require('../../assets/images/lilBar1.png')}
          />
          <View>
            <Text style={[styles.text, (styles as any)[type!]]}>{text}</Text>
          </View>
        </Animated.View>
      </TouchableWithoutFeedback>
    );
  }
}
